import React from 'react';
function Desktop({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <rect
        width="18"
        height="12"
        x="3"
        y="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        rx="2"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 17h8v1a1 1 0 01-1 1H9a1 1 0 01-1-1v-1z"
      />
    </svg>
  );
}

export default Desktop;
